import { FC, useEffect } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { ResultAsync } from 'store/result/resultAsync';
import { resultActions } from 'store/result/resultSlice';
import { getAnalytics } from 'store/result/resultSelectors';
import Events from 'types/Events';
// Components
import { Loader } from 'components/Utilities';
import RadialBar from './RadialBar';
// i18next
import { useTranslation } from 'react-i18next';

const Analytics:FC = () => {
  const { t } = useTranslation();
  
  const dispatch = useAppDispatch();
  
  const analytics = useAppSelector(getAnalytics);

  useEffect(() => {
    dispatch(ResultAsync.fetchAnalytics());
    return () => {
      dispatch(resultActions.setInitialField('analytics'));
    }
    // eslint-disable-next-line
  }, []);

  if ( !analytics ) return <Loader />;

  const { quizzes, plays, conversions, events } = analytics;

  const quizStarts = events.find(e => e.value === Events.QuizStart)?.count || 0;

  return (
    <div className="pt-8">
      <div className="flex flex-col font-medium">
        <div className="flex flex-wrap justify-between items-center">
          <RadialBar label={t('pages.analytics.quizzes')} value={quizzes} />
          <RadialBar label={t('pages.analytics.playersStartedQuiz')} value={quizStarts} />
          <RadialBar label={t('pages.analytics.playersCompletedQuizzes')} value={plays} />
          <RadialBar label={t('pages.analytics.playersRegistered')} value={conversions} />
        </div>
      </div>
    </div>
  )
}

export default Analytics;
